import { handleActions } from 'redux-actions';

export default handleActions(
	{
		GET_SHOP_LIST_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_SHOP_INFO_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_RESERVATION_LIST_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_RESERVATION_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),
	},
	{
		shop: [],
		list: [],
		count: '',
		shopInfo: '',
		shopTime: '',
		reservationForm: {
			id: '',
			type: '',
			remarks: '',
			name: '',
			date: '',
			time: '',
			timeId: '',
		},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/reservation.js